module.exports = __webpack_public_path__ + "catalog/items/firesafety/AssemblyPoint/AssemblyPoint.svg";